import { PJAX_MAIN_CONTAINER_SELECTOR } from './constants';
import { addUppyFieldsToForm } from './filesUpload';


export const initPjax = () => {
  // Hook to use PJAX.
  $(document).pjax('a[data-pjax]', PJAX_MAIN_CONTAINER_SELECTOR);

  // Submit forms using PJAX.
  $(document).on('submit', 'form[data-pjax]', function submitForm(event) {
    event.preventDefault();
    // If uppy Redux State is populated add associated inputs to form.
    addUppyFieldsToForm(event.target);
    $.pjax.submit(event, PJAX_MAIN_CONTAINER_SELECTOR);
  });

  $.pjax.defaults.timeout = 0;
  $(document).on('pjax:error pjax:timeout', function pjaxSuppressErrors() {
    return false;
  });
};
